import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/auth/slice';
import userSlice from './slices/user/slice';
import influencerSlice from './slices/influencer/slice';
import feedSlice from './slices/feed/slice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    userInfo: userSlice,
    influencerInfo: influencerSlice,
    feedInfo: feedSlice,
  },
  devTools: false,
});
